import { DropdownProps } from "ct-design";
import { FareCards } from "../itinerary/types";

export interface Seat {
  seatNum: string;
  row: number;
  col: number;
  width: number;
  height: number;
  seatType: string;
  fareKey: string;
  statusKey: seatStatus;
  deck?: string;
  isSelected?: boolean;
}
export interface ChartData {
  [solutionId: string]: {
    cc: scProps;
    maxAllowedSeats: number;
    chart: chartPros;
    itinDetails: {
      itineraryId: string;
      journey: [
        {
          pickup: PickDropProps;
          dropOff: PickDropProps;
          seats: [
            {
              seatNumber: string;
            }[]
          ];
        }
      ];
    };
    fareInfo?: Record<string, FareCards>;
  };
}

export interface scProps {
  solutionId: string;
  searchId: string;
  fromCityId: number;
  toCityId: number;
  journeyDate: string;
  fromCityName: string;
  toCityName: string;
  userId: number | null;
  currency: string;
  operatorName: string;
  arrTime: string;
  deptTime: string;
  isGovt: boolean;
  busId: number;
  travelDuration: string;
  displayBusType: string;
  pricePerSeat: string;
}

export interface cancellationPolicy {
  text: string[];
  policy: {
    duration: string;
    refundPer: number;
    amount: number;
    cancellationPer: number;
    refundAmount?: number;
    strikeThroughCancellationPer?: number;
    benefitLabel?: string;
    isCFNRBenefit?: boolean;
  }[];
}

export interface DropOffData {
  dropOffTime: string | number;
  dropOffName: string;
  dropOffCode?: string;
  latitude?: string;
  longitude?: string;
  contact?: string;
  address?: string;
}

export interface PickUpData {
  pickupTime: string | number;
  pickupName: string;
  pickupCode?: string;
  pickupCrossed?: boolean;
  landmark?: JSX.Element;
  pickupCharge?: number;
  latitude?: string;
  longitude?: string;
  contact?: string;
  address?: string;
}

export interface PickDropProps {
  pickupName?: string;
  pickupCode?: string;
  dropOffName?: string;
  dropOffCode?: string;
  landmark: JSX.Element;
  pickupCharge: number;
  code: string;
  time: string;
  name: string;
  address?: string;
  isCrossed?: boolean;
  latitude?: string;
  longitude?: string;
  contact?: string;
}

export interface fareCategoryProps {
  category: string;
  amount: number;
  code: string;
  label: string;
}

export interface fareProps {
  [key: string]: fareCategoryProps;
}

export interface chartPros {
  chartInstanceId: string;
  totalSleeper: number;
  totalSemiSleeper: number;
  totalSeater: number;
  totalSeats: number;
  decks: number;
  lower: {
    maxRows: number;
    maxCols: number;
  };
  upper: {
    maxRows: number;
    maxCols: number;
  };
  lowerDeck: Seat[];
  upperDeck: Seat[];
  fares: { [key: string]: fareProps };
  amenities: string[];
  availableSeats: { lower: number; upper: number };
  pickups: PickDropProps[];
  dropOffs: DropdownProps[];
  cancellationPolicy: cancellationPolicy;
  review?: reviewProps;
}

export enum seatStatus {
  "NOT_AVAILABLE" = "NOT_AVAILABLE",
  "AVAILABLE_FOR_ALL" = "AVAILABLE_FOR_ALL",
  "AVAILABLE_ONLY_FOR_MALE" = "AVAILABLE_ONLY_FOR_MALE",
  "AVAILABLE_ONLY_FOR_FEMALE" = "AVAILABLE_ONLY_FOR_FEMALE",
  "BOOKED_BY_MALE" = "BOOKED_BY_MALE",
  "BOOKED_BY_FEMALE" = "BOOKED_BY_FEMALE",
}
// 0,1,2,3,-2,-3
export interface chartProps {
  openChart: () => void;
}

export interface proceedButtonProps {
  selSeats?: Seat[] | unknown;
  selInfo: {
    fare: Record<string, number>;
    fareCategory: Record<string, string>;
    fareLabel: Record<string, string>;
    seats: number;
  };
  handleProceed: (() => void) | unknown;
  viewFareBreakupAnalyticsActn?: () => void;
  showSeatInfo: boolean;
  btnText?: string;
  disableContinue?: boolean;
  CustomComp?: React.FC;
  onlyCT_TF?: boolean;
  loading?: boolean;
  showTax?: boolean;
}

export interface reviewProps {
  rating?: number;
  ratingCount?: number;
  ratingData?: { label?: string; rating?: number }[];
  breakUp?: Record<string, number>;
}

export interface pickups {
  data: Record<string, unknown>[];
}

export interface dropoff {
  data: Record<string, unknown>[];
}

export interface pickdrop {
  data: PickDropProps[];
  headerText: string;
  placeholder: string;
  selData: PickDropProps;
  codeKey: string;
  codeTime: string;
  busId: number;
  action: any;
}

export enum buttonLabel {
  "PROCEED" = "Add travellers",
  "PICK_BUTTON_TEXT" = "Select pick-up point",
  "DROP_BUTTON_TEXT" = "Select drop-off point",
}

export enum headerLabel {
  "PICK_HEADER_LABEL" = "Choose pick-up point",
  "DROP_HEADER_LABEL" = "Choose drop-off point",
}

export enum placeHolder {
  "PICK_PLACEHOLDER" = "Search for pick-up point",
  "DROP_PLACEHOLDER" = "Search for drop-off point",
}

export enum viewType {
  "seat" = "seat",
  "pick" = "pick",
  "drop" = "drop",
}

export enum tabType {
  "Seat" = "Seat",
  "Amenities" = "Amenities",
  "Policies" = "Policies",
  "Ratings" = "Ratings",
}

export enum fareType {
  "SUP_BF" = "SUP_BF",
  "SUP_RESV" = "SUP_RESV",
  "SUP_SRV" = "SUP_SRV",
  "SUP_CNC" = "SUP_CNC",
  "SUP_CONV" = "SUP_CONV",
  "SUP_TOLL" = "SUP_TOLL",
  "SUP_TF" = "SUP_TF",
  "SUP_DIS" = "SUP_DIS",
  "SUP_LEVY" = "SUP_LEVY",
  "SUP_OTHER" = "SUP_OTHER",
  "SUP_TAX" = "SUP_TAX",
  "CT_TF" = "CT_TF",
}

export interface toolTipType {
  key: string;
  cX: number;
  cY: number;
  textToShow: JSX.Element;
  arrowLeft: number;
  isGenderRestricted: boolean;
}

export interface SearchQuery {
  fromCity: string;
  toCity: string;
  journeyDate: string;
}
export interface ChartQuery {
  solutionId: string;
  searchId: string;
  itineraryId: string | null;
}

export interface CreateItineraryQuery {
  itineraryId: string | null;
  journey: [
    {
      solutionId: string;
      searchId: string;
      chartInstanceId: string;
      pickupCode: string;
      dropOffCode: string;
      seats: [
        {
          seatNumber: string;
        }
      ];
    }
  ];
}

export interface TripQuery {
  tripId: string;
}

export interface CancelQuery {
  tripId: string;
}
